export default "__VITE_ASSET__sYijcFEZ__"